const rankingItems = [
  { rank: 1, title: '顶流男星深夜密会神秘女子，酒店共度8小时', heat: '🔥 128.6万', tag: 'NEW' },
  { rank: 2, title: '知名网红直播间失言，品牌方连夜宣布解约', heat: '🔥 96.3万', tag: 'HOT' },
  { rank: 3, title: '综艺录制现场爆发冲突，两导师当场翻脸离席', heat: '🔥 87.1万', tag: 'HOT' },
  { rank: 4, title: '女星走红毯礼服滑落，现场媒体疯狂抓拍', heat: '🔥 75.8万', tag: '' },
  { rank: 5, title: '选秀节目被曝票数造假，节目组紧急发声明', heat: '🔥 62.4万', tag: 'NEW' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">吃瓜热度榜</h2>
        <p className="text-sm text-foreground-500 mb-8">实时更新的网红吃瓜网站热度排行，今天大家都在吃这些瓜</p>
        <div className="flex flex-col gap-2">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-colors cursor-pointer group"
            >
              <span className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </span>
              <span className="flex-1 text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                {item.title}
              </span>
              {item.tag && (
                <span className={`flex-shrink-0 px-2 py-0.5 rounded text-xs font-semibold ${
                  item.tag === 'NEW' ? 'bg-primary-100 text-primary-700' : 'bg-accent-100 text-accent-700'
                }`}>
                  {item.tag}
                </span>
              )}
              <span className="flex-shrink-0 text-xs text-foreground-500 font-medium">{item.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}